import { ENDPOINT } from 'shared/constants/DefaultValues';
import { RecoverPasswordResponseError } from '../models/RecoverPasswordResponseError';
import { RecoverPasswordFormData } from '../models/RecoverPasswordFormData';
import { RecoverPasswordData } from '../models/RecoverPasswordData';

export const sendRecoverPassword = async (
  recoverPasswordFormData: RecoverPasswordFormData
): Promise<RecoverPasswordData> => {
  const route = `${ENDPOINT}/usuarios/recoverpassword`;

  try {
    const response = await fetch(route, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(recoverPasswordFormData),
    });

    if (!response.ok) {
      const responseData = await response.json().catch(() => ({}));
      throw new RecoverPasswordResponseError({
        status: response.status,
        message: responseData?.message ?? 'Error inesperado',
      });
    }

    if (response.status === 204) {
      return {
        username: recoverPasswordFormData.username,
        mail: '',
      };
    }

    return await response.json();

  } catch (error: any) {
    if (error instanceof RecoverPasswordResponseError) {
      throw error;
    }

    throw new RecoverPasswordResponseError({
      status: 500,
      message: 'Error de red o servidor no disponible',
    });
  }
};
